<template>
  <main class="full-height">
    <v-content>
      <v-container fluid grid-list-xl>
        <v-layout justify-center row wrap>
          <v-flex md5 class="text-xs-center">
            <v-layout row wrap>
              <button
                type="button"
                class="button-return-filters"
                @click="$router.go(-1)"
              >
                <v-icon>arrow_back</v-icon>
              </button>
              <v-flex xs12 class="mb-4">
                <h2 class="font-weight-black">
                  Consulta de Recibos/Extrato de Comissão
                </h2>
              </v-flex>

              <v-flex xs12>
                <v-card class="form-card">
                  <v-card-title class="justify-center"
                    >Permitirá você listar seus recibos de comissão, podendo
                    efetuar a impressão desses documentos.</v-card-title
                  >
                  <v-layout row wrap>
                    <v-container>
                      <v-text-field
                        @keyup.enter="pesquisar()"
                        v-model="numeroRecibo"
                        :placeholder="' '"
                        :label="'Digite o número do recibo'"
                        type="number"
                        class="jns-input mb-3"
                      >
                      </v-text-field>
                      <v-text-field
                        @keyup.enter="pesquisar()"
                        v-model="dataInicioEmissao"
                        slot="activator"
                        :placeholder="'dia/mês/ano'"
                        :label="'Digite a data de início de emissão'"
                        :rules="[rules.validDateFormat]"
                        class="jns-input mb-3"
                        append-icon="event"
                      >
                      </v-text-field>
                      <v-text-field
                        @keyup.enter="pesquisar()"
                        v-model="dataFimEmissao"
                        :placeholder="'dia/mês/ano'"
                        :label="'Digite a data de fim de emissão'"
                        :rules="[rules.validDateFormat]"
                        class="jns-input mb-3"
                        append-icon="event"
                      >
                      </v-text-field>

                      <v-layout row wrap class="justify-center">
                        <v-flex xs8>
                          <button
                            class="jns-button yellow-button"
                            @click="pesquisar()"
                          >
                            Pesquisar
                          </button>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </main>
</template>

<script lang="js">
import ViewMixin from "@/mixins/ViewMixin";
export default {
  name: "Recibos",
  mixins: [ViewMixin],
  data: () => ({
    numeroRecibo: "",
    dataInicioEmissao: "",
    dataFimEmissao: "",
    nomeFavorecido: "",
    rules: {
      validDateFormat: (v) =>
        (v &&
          (!!v.match(/^\d{1,2}\/\d{1,2}\/\d{4}$/) ||
            "Insira um formato válido de data")) ||
        true,
    },
  }),
  methods: {
    async pesquisar() {
      const {
        numeroRecibo,
        dataInicioEmissao,
        dataFimEmissao,
        nomeFavorecido,
      } = this;

      try {
        if (
          this.safeDateForDispatch(dataInicioEmissao) &&
          this.safeDateForDispatch(dataFimEmissao)
        ) {
          await this.$store.commit("SET_SEARCH_DATA", {
            numeroRecibo,
            dataInicioEmissao,
            dataFimEmissao,
            nomeFavorecido,
          });
          this.$router.push({ path: `/recibos/listar` });
        } else {
          this.setErrorModal({
            title: "Dados inválidos.",
            message: "Preencha os dados de data adequadamente!",
          });
        }
      } catch (e) {
        this.defaultHandlerError(e);
      }
    },

    safeDateForDispatch(date) {
      return !date ? true : !!date.match(/^\d{1,2}\/\d{1,2}\/\d{4}$/);
    },
  },
};
</script>

<style lang="scss" scoped>
#jns {
  .button-return-filters {
    transition: all 0.3s;
    position: absolute;
    border-radius: 50%;
    background-color: #f1e41e;

    i {
      padding: 5px;
      font-size: 2rem;
      color: #061d45;
    }

    &:hover {
      background-color: #061d45;

      i {
        color: #fff;
      }
    }
  }

  @media (max-width: 760px) {
    .button-return-filters {
      position: relative;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/router/views/ExtratosRecibos/Recibos/Pesquisar.vue